/* KAPKA — Ürün kartı renk seçenekleri
   Tek, belge düzeyinde dinleyici: sonradan yüklenen kartlarda da (ör. "Bunları da beğenebilirsiniz",
   filtreleme sonrası ızgara) çalışır. Masaüstünde üzerine gelince, her cihazda tıklayınca/dokununca. */
(function () {
  if (window.kapkaCardSwatches) return;
  window.kapkaCardSwatches = true;

  function variantsOf(wrapper) {
    if (!wrapper._kpcVariants) {
      try { wrapper._kpcVariants = JSON.parse(wrapper.dataset.variants || '[]'); } catch (e) { wrapper._kpcVariants = []; }
    }
    return wrapper._kpcVariants;
  }

  function select(sw) {
    var wrapper = sw.closest('[data-product-card]');
    if (!wrapper || sw.classList.contains('is-active') && wrapper._kpcColor === sw.dataset.color) return;
    var variant = variantsOf(wrapper).find(function (v) { return v.color === sw.dataset.color; });
    if (!variant) return;
    wrapper._kpcColor = sw.dataset.color;

    wrapper.querySelectorAll('[data-kpc-swatch]').forEach(function (s) {
      s.classList.toggle('is-active', s === sw);
    });

    var img = wrapper.querySelector('[data-kpc-img]');
    if (img && variant.image && img.getAttribute('src') !== variant.image) {
      img.classList.add('kpc-transitioning');
      setTimeout(function () {
        if (variant.srcset) img.srcset = variant.srcset; else img.removeAttribute('srcset');
        img.src = variant.image;
        img.classList.remove('kpc-transitioning');
      }, 160);
    }

    wrapper.querySelectorAll('[data-kpc-link]').forEach(function (el) { el.href = variant.url; });

    var priceEl = wrapper.querySelector('[data-kpc-price]');
    if (priceEl && variant.money) {
      priceEl.innerHTML = variant.compare_at_price > variant.price
        ? '<span class="kpc-card__price--compare">' + variant.compare_money + '</span><span class="kpc-card__price--sale">' + variant.money + '</span>'
        : '<span>' + variant.money + '</span>';
    }
  }

  function swatchFrom(e) {
    return e.target.closest ? e.target.closest('[data-kpc-swatch]') : null;
  }

  document.addEventListener('click', function (e) {
    var sw = swatchFrom(e);
    if (!sw) return;
    e.preventDefault();
    select(sw);
  });
  document.addEventListener('mouseover', function (e) {
    var sw = swatchFrom(e);
    if (sw && window.matchMedia('(hover: hover)').matches) select(sw);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var sw = swatchFrom(e);
    if (!sw) return;
    e.preventDefault();
    select(sw);
  });
})();
